import { colors } from "@theme/colors"
import styles from "./styles.module.scss"
import CruiseIcon from "../../assets/icons/CruiseIcon"
import SaveIconOutline from "~icons/eva/save-outline"
import ArrowsIcon from "../../assets/icons/ArrowsIcon"
import SlidersIcon from "../../assets/icons/SlidersIcon"
import EditIcon from "~icons/eva/edit-2-outline"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../models/helpers/useStores"

export const EmptyCruiseList = observer(() => {
  const rootStore = useStores()

  return (
    <div className={styles.emptyCruiseListContainer} data-test-id="cruise-list-container">
      <div className={styles.emptyCruiseListHeading}>
        <div className={styles.emptyCruiseListTitleContainer}>
          <CruiseIcon />
          <h1 className={styles.emptyCruiseListTitle}>Cruises</h1>
        </div>
        <div className={styles.emptyCruiseListHeadingButtons}>
          <button className={styles.emptyCruiseListActionButton} disabled>
            <SaveIconOutline className={styles.emptyCruiseListActionButtonIcon} />
          </button>
          <button className={styles.emptyCruiseListActionButton} disabled>
            <ArrowsIcon color={colors.iconTertiary} />
          </button>
          <button className={styles.emptyCruiseListActionButton} disabled>
            <SlidersIcon color={colors.iconTertiary} />
          </button>
        </div>
      </div>
      <div className={styles.emptyCruiseContainer}>
        <div>
          <p className={styles.emptyCruiseContainerTitle}>Ready to set sail?</p>
          <p className={styles.emptyCruiseContainerSubtitle}>
            Edit the trip details to unlock the full itinerary.
          </p>
          <button
            className={styles.emptyCruiseContainerButton}
            onClick={() => rootStore.setProp("visibleModal", "editTrip")}
          >
            <EditIcon className={styles.emptyCruiseContainerButtonIcon} />
            <p className={styles.emptyCruiseContainerButtonText}>Edit trip details</p>
          </button>
        </div>
      </div>
    </div>
  )
})
